import { OcExportEntityModel } from 'src/graphql/types';
import { ExportSource, LegacyExportSource } from './Exports.types';

export const toOcExportEntityModel: Record<ExportSource & LegacyExportSource, OcExportEntityModel> = {
  contracts: OcExportEntityModel.Contracts,
  cost_centers: OcExportEntityModel.CostCenters,
  expenses: OcExportEntityModel.Expenses,
  invoices: OcExportEntityModel.Invoices,
  job_applications: OcExportEntityModel.JobApplications,
  job_families: OcExportEntityModel.JobFamilies,
  job_family_groups: OcExportEntityModel.JobFamilyGroups,
  job_profiles: OcExportEntityModel.JobProfiles,
  business_sites: OcExportEntityModel.BusinessSites,
  organizations: OcExportEntityModel.Organizations,
  people: OcExportEntityModel.People,
  policy_rules: OcExportEntityModel.PolicyRules,
  rate_cards: OcExportEntityModel.RateCards,
  roles: OcExportEntityModel.Roles,
  suppliers: OcExportEntityModel.Suppliers,
  timesheets: OcExportEntityModel.Timesheets,
  users: OcExportEntityModel.Users,
  engagements: OcExportEntityModel.Engagements,
  worker_engagements: OcExportEntityModel.WorkerEngagements,
  work_postings: OcExportEntityModel.WorkPostings,
  work_requests: OcExportEntityModel.WorkRequests,
  [ExportSource.CustomObjects]: OcExportEntityModel.CustomObjects
};
